module.exports = __webpack_public_path__ + "img/screen_purchase_compare.79a9d328.png";